var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-cctv",class:_vm.iconColor,attrs:{"title":_vm.lastError}})}
var staticRenderFns = []

export { render, staticRenderFns }